import { z } from "zod";

import { ProductVariantEventStatusList } from "../schemas/products";
import { castToString } from "../utils";

import { ExperienceProductVariantDtoSchema } from "./experience-products";
import { OfferProductInclusionTypeList } from "./offer-products";
import { VariationDtoSchema } from "./variations";

export const ProductVariantDtoSchema = z.object({
  id: z.string().uuid(),
  productId: z.string(),
  variantId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string(),
  experienceId: z.string().uuid(),
  variationId: z.string().uuid(),
  offerId: z.string().uuid().nullish(),
  price: castToString.nullish(),
  compareAtPrice: castToString.nullish(),
  subscriptionDiscount: z.string().nullish(),
  subscriptionDiscountType: z.string().nullish(),
  handle: z.string().nullish(),
  dupProductId: z.string().nullish(),
  dupVariantId: z.string().nullish(),
  dupHandle: z.string().nullish(),
  variation: VariationDtoSchema,
  isDeleted: z.boolean().nullish(),
  eventStatus: z.enum(ProductVariantEventStatusList).nullish(),
  inclusionType: z.enum(OfferProductInclusionTypeList),
});

export type ProductVariantDto = z.infer<typeof ProductVariantDtoSchema>;

export const CreatEProductVariantDtoSchema = ProductVariantDtoSchema.omit({
  variation: true,
});
export type CreateProductVariantDto = z.infer<
  typeof CreatEProductVariantDtoSchema
>;

export const RedactedProductVariantForPutProductVariantsFromS3DtoSchema =
  z.object({
    id: z.string().uuid(),
    productId: z.string(),
    variantId: z.string(),
    productTitle: z.string(),
    price: castToString.nullish(),
    compareAtPrice: castToString.nullish(),
    subscriptionDiscount: z.string().nullish(),
    subscriptionDiscountType: z.string().nullish(),
    handle: z.string().nullish(),
    dupProductId: z.string().nullish(),
    dupVariantId: z.string().nullish(),
    variation: z.object({
      id: z.string().uuid(),
      name: z.string(),
      isControl: z.boolean(),
    }),
  });

export type RedactedProductVariantForPutProductVariantsFromS3Dto = z.infer<
  typeof RedactedProductVariantForPutProductVariantsFromS3DtoSchema
>;

export const FileProductDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  image: z.string(),
  variants: ExperienceProductVariantDtoSchema.array(),
  requiresSellingPlan: z.boolean(),
});
export type FileProductDto = z.infer<typeof FileProductDtoSchema>;
